import ls from '../../utils/localStorage.js';
import { getCommons } from '../../api/api';

const state = {
  common_list: ''
}

const mutations = {
    UPDATE_COMMON_LIST(state,payload) {
        state.common_list = JSON.parse(payload);
    }
}

const getters = {

}

const actions = {

    // 获取门店列表
    requestCommons(store,item) {
        getCommons(item.city).then( data => {
            item.thit.loading = true;
            store.commit('UPDATE_COMMON_LIST',JSON.stringify(data));
        }).catch(error => {
            
        })
    }

}

export default {
    state,
    mutations,
    getters,
    actions
}
